<template>
  <ReviewsCategoriesTableContainer
    v-bind="tableContainerAttrs"
    v-on="tableContainerEvents"
  >
    <template v-slot:customColumn="{ item, columnName }">
      <ReviewsCategoriesColorTriadTableColumn
        :value="item[columnName]"
        :sentiment="item.sentiment[columnName]"
        :column-name="columnName"
        :is-comparison-enabled="isComparing"
      />
    </template>
  </ReviewsCategoriesTableContainer>
</template>

<script>
import ReviewsCategoriesColorTriadTableColumn from "./ReviewsCategoriesColorTriadTableColumn.vue";
import ReviewsCategoriesTableContainer from "./ReviewsCategoriesTableContainer.vue";
import { categoryTableWrapper } from "@/helpers/mixins/category-table-wrapper.js";
import { sentimentHeaders } from "@/config/categories-table-columns";
export default {
  name: "ReviewsCategoriesAverageTable",
  mixins: [categoryTableWrapper],
  components: {
    ReviewsCategoriesColorTriadTableColumn,
    ReviewsCategoriesTableContainer
  },
  data() {
    return {
      headers: sentimentHeaders(),
      formattedGridData: {
        results: [],
        count: 0
      },
      defaultFilters: {
        order_by: "reviews_count",
        order_direction: "desc"
      }
    };
  },
  methods: {
    getFormattedGridData() {
      const { basic, comparison } = this.gridData;
      const results = basic.results.map((item, index) => ({
        ...item,
        reviews_count: [
          item.reviews_count,
          this.isComparing ? comparison.results[index].reviews_count : null
        ],
        sentiment: Object.entries(item.sentiment).reduce(
          (acc, [key, basicSentiment]) => {
            const comparisonSentiment = this.isComparing
              ? comparison.results[index].sentiment[key]
              : null;

            acc[key] = {
              percentage: [
                basicSentiment.percentage,
                comparisonSentiment
                  ? comparisonSentiment.percentage
                  : comparisonSentiment
              ],
              reviews_count: [
                basicSentiment.reviews_count,
                comparisonSentiment
                  ? comparisonSentiment.reviews_count
                  : comparisonSentiment
              ]
            };
            return acc;
          },
          {}
        )
      }));
      return {
        results,
        count: basic.count
      };
    }
  },
  watch: {
    basicFilters: {
      async handler() {
        await this.getGridData();
      },
      deep: true
    }
  }
};
</script>
